import {forEachNode, ready} from '@/shared'
import {renderCarousel} from '@/modules/carousel'
import { renderProductsListRatings } from '@/modules'

const DistanceToLoad = 300
const CarouselElementSelector = '.js-carousel'

function sharedCarouselOptions () {
  return {
    items: 4,
    responsive: {
      320: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  }
}

function getCarouselOptions (carouselElement) {
  if (shouldLazyLoad(carouselElement)) {
    return {
      ...sharedCarouselOptions(),
      lazyload: false
    }
  } else {
    return {
      ...sharedCarouselOptions(),
      lazyload: true
    }
  }
}

function shouldLazyLoad (carouselElement) {
  return carouselElement.getAttribute('data-lazy-loading') === 'true'
}
function renderRatings () {
  renderProductsListRatings()
}

ready(function () {
  renderRatings()
  const bodyElement = document.querySelector('body')
  bodyElement.addEventListener('productsListLoaded', () => renderRatings())
  const carouselNodes = document.querySelectorAll(CarouselElementSelector)
  forEachNode(carouselNodes, carouselElement => {
    return renderCarousel(carouselElement, {
      carouselOptions: getCarouselOptions(carouselElement),
      distanceToLoad: DistanceToLoad
    })
  })
})



// WEBPACK FOOTER //
// ./src/products-carousel.js